export default class Certification {
  constructor(API) {
    this.api = API;
  }
  async createCertification(certificationObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = `/tenant/${this.api.config.tenantID}/certification/new`;
    req.body = certificationObj;
    return await req.exec();
  }
  async updateCertification(certificationObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = `/tenant/${this.api.config.tenantID}/certification/${certificationObj.id}`;
    req.body = certificationObj;
    return await req.exec();
  }
  async deleteCertification(certificationID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = `/tenant/${this.api.config.tenantID}/certification/${certificationID}`;
    return await req.exec();
  }
  async getCertification(certificationID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/tenant/${this.api.config.tenantID}/certification/${certificationID}`;
    return await req.exec();
  }
  async getCertifications(optTenantID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = `/tenant/${optTenantID || this.api.config.tenantID}/certifications`;
    return await req.exec();
  }
}
